module.exports = __webpack_public_path__ + "img/quarter-user-join-btn-bg@2x.7bcfe99c.png";